<template>
  <span
    :class="['simple-price', mode == 'regular_price'?'regular_price regular_price_text':'price_text']"
    :style="{ color: color, fontSize: fontSize }"
  >
    {{ getSymbolFromCurrency($store.state.pricetype) }}
    {{ computePrice(price, true, $store.state.pricetype) }}
  </span>
</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
export default {
  props: {
    price: { require: true },
    mode: {}, //使用模式区分原价现价
    color: {},
    fontSize: {},
  },
  data() {
    return {
      getSymbolFromCurrency: "",
    };
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency;
  },
};
</script>
<style scoped lang='scss'>
.simple-price {
  color: #1f2537;
}
.regular_price {
  text-decoration: line-through !important;
  color: #979cac;
}
</style>